/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ErrorReportsQueryVariables = {||};
export type ErrorReportsQueryResponse = {|
  +greenMachineIssues: ?$ReadOnlyArray<?{|
    +id: string,
    +numLineups: number,
    +minSalary: number,
    +maxSalary: number,
    +playersPerLineup: ?number,
    +reportedBy: ?{|
      +username: string
    |},
    +errorReport: ?boolean,
    +errorMessage: ?string,
    +greenmachinelineupsetSet: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string
        |}
      |}>
    |},
    +slate: {|
      +id: string,
      +gameType: {|
        +id: string,
        +sport: {|
          +id: string,
          +name: string,
        |},
        +gametypelineupsetSet: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +lineupSet: {|
                +lineuprosterslotSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +order: number,
                      +amount: number,
                      +rosterSlot: {|
                        +name: string
                      |},
                      +selectable: boolean,
                    |}
                  |}>
                |}
              |}
            |}
          |}>
        |},
      |},
    |},
  |}>
|};
export type ErrorReportsQuery = {|
  variables: ErrorReportsQueryVariables,
  response: ErrorReportsQueryResponse,
|};
*/


/*
query ErrorReportsQuery {
  greenMachineIssues {
    id
    numLineups
    minSalary
    maxSalary
    playersPerLineup
    reportedBy {
      username
      id
    }
    errorReport
    errorMessage
    greenmachinelineupsetSet {
      edges {
        node {
          id
        }
      }
    }
    slate {
      id
      gameType {
        id
        sport {
          id
          name
        }
        gametypelineupsetSet {
          edges {
            node {
              lineupSet {
                lineuprosterslotSet {
                  edges {
                    node {
                      order
                      amount
                      rosterSlot {
                        name
                        id
                      }
                      selectable
                      id
                    }
                  }
                }
                id
              }
              id
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numLineups",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minSalary",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxSalary",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playersPerLineup",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorReport",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "GreenMachineLineupSetTypeConnection",
  "kind": "LinkedField",
  "name": "greenmachinelineupsetSet",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GreenMachineLineupSetTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GreenMachineLineupSetType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SportType",
  "kind": "LinkedField",
  "name": "sport",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectable",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ErrorReportsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GreenMachineSessionType",
        "kind": "LinkedField",
        "name": "greenMachineIssues",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserType",
            "kind": "LinkedField",
            "name": "reportedBy",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateType",
            "kind": "LinkedField",
            "name": "slate",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GameTypeType",
                "kind": "LinkedField",
                "name": "gameType",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GameTypeLineupSetTypeConnection",
                    "kind": "LinkedField",
                    "name": "gametypelineupsetSet",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GameTypeLineupSetTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GameTypeLineupSetType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LineupSetType",
                                "kind": "LinkedField",
                                "name": "lineupSet",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LineupRosterSlotTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "lineuprosterslotSet",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LineupRosterSlotTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LineupRosterSlotType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "RosterSlotType",
                                                "kind": "LinkedField",
                                                "name": "rosterSlot",
                                                "plural": false,
                                                "selections": [
                                                  (v9/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ErrorReportsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GreenMachineSessionType",
        "kind": "LinkedField",
        "name": "greenMachineIssues",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserType",
            "kind": "LinkedField",
            "name": "reportedBy",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateType",
            "kind": "LinkedField",
            "name": "slate",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GameTypeType",
                "kind": "LinkedField",
                "name": "gameType",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GameTypeLineupSetTypeConnection",
                    "kind": "LinkedField",
                    "name": "gametypelineupsetSet",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GameTypeLineupSetTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GameTypeLineupSetType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LineupSetType",
                                "kind": "LinkedField",
                                "name": "lineupSet",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LineupRosterSlotTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "lineuprosterslotSet",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LineupRosterSlotTypeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LineupRosterSlotType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "RosterSlotType",
                                                "kind": "LinkedField",
                                                "name": "rosterSlot",
                                                "plural": false,
                                                "selections": [
                                                  (v9/*: any*/),
                                                  (v0/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v13/*: any*/),
                                              (v0/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v0/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v0/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a36214e4509eff67bc4e274448043bd",
    "id": null,
    "metadata": {},
    "name": "ErrorReportsQuery",
    "operationKind": "query",
    "text": "query ErrorReportsQuery {\n  greenMachineIssues {\n    id\n    numLineups\n    minSalary\n    maxSalary\n    playersPerLineup\n    reportedBy {\n      username\n      id\n    }\n    errorReport\n    errorMessage\n    greenmachinelineupsetSet {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    slate {\n      id\n      gameType {\n        id\n        sport {\n          id\n          name\n        }\n        gametypelineupsetSet {\n          edges {\n            node {\n              lineupSet {\n                lineuprosterslotSet {\n                  edges {\n                    node {\n                      order\n                      amount\n                      rosterSlot {\n                        name\n                        id\n                      }\n                      selectable\n                      id\n                    }\n                  }\n                }\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5b5f924f0836ea9e9ddffffe8fa0cf3f';

module.exports = node;
